import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { getPaywallState, savePaywallState } from '@/utils/paywallHelpers';

export default function PaymentCanceled() {
  useEffect(() => {
    // Clear pending payment state but keep paywall active
    const paywallState = getPaywallState();
    savePaywallState({
      ...paywallState,
      hasPendingPayment: false
    });
    
    // Clear pending payment from localStorage
    localStorage.removeItem('pendingPayment');
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-red-100 dark:bg-red-900 rounded-full flex items-center justify-center mb-4">
            <XCircle className="w-8 h-8 text-red-600 dark:text-red-400" />
          </div>
          <CardTitle className="text-2xl">Payment Canceled</CardTitle>
          <CardDescription>
            Your payment was canceled. The paywall will remain active until payment is completed. You can try again from the app.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild className="w-full">
            <Link to="/">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to App
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}